import SelectAsyncPaginate from './SelectAsyncPaginate';

export default SelectAsyncPaginate;
